import { logProgramChange } from '@shoflo/studio-redux/utils';

import { sceneBuilder } from '@studio/program/sceneBuilder/sceneBuilder';
import { getSceneLayerSources } from '@studio/program/utils/scene';
import { setProgram } from 'actions/Broadcast';
import { attachAudioPresenterSources } from 'utils/broadcastSourceHelper';

/**
 * @param {string} sourceId
 * @param {object} deleteParams data to help understand subsequent action to perform
 */
export default (sourceId, deleteParams = {}) => {
  return (dispatch, getState) => {
    const { program, backgrounds, attendeeMuteStatus, brandingSettings } =
      getState();
    if (!deleteParams.isBackgroundSource) {
      // layer._id within the condition handles the case where source
      // is an overlay or a banner then the layer._id is the id of the overlay or banner
      const sourceInProgram = program.layers.find(
        layer =>
          layer?.source?._id === sourceId ||
          layer?._id === sourceId ||
          layer?.source?._id === deleteParams?.replacementSource?._id
      );
      if (sourceInProgram) {
        const updatedLayers = program.layers.filter(
          layer => layer?.source?._id !== sourceId && layer?._id !== sourceId
        );
        const sources = updatedLayers.map(layer => layer.source);
        const layout = {
          id: program.layout,
          title: program.title,
          thumbnail: program.thumbnail
        };
        const isOverlayOrBanner = program.layers.find(
          layer => layer._id === sourceId
        );
        let layers = updatedLayers;
        // Should only rebuild layer with deleted/replaced source is not
        // an overlay or a banner source
        if (!isOverlayOrBanner) {
          const sceneLayers = [
            'SCENE_LAYER',
            ...getSceneLayerSources(updatedLayers)
          ];
          const withAudioPresenterSources = attachAudioPresenterSources(
            sources,
            attendeeMuteStatus
          );
          const builtScene = sceneBuilder(
            layout,
            withAudioPresenterSources,
            sceneLayers,
            {},
            {},
            brandingSettings?.fonts
          );
          layers = builtScene.layers;
        }
        const updatedProgram = {
          ...program,
          layers
        };
        dispatch(setProgram(updatedProgram));
        logProgramChange(
          getState,
          'updateDeletedSourceInProgram action - removing source (NOT layer source)'
        );
      }
    } else {
      const backgroundInProgram = program.style.backgroundId === sourceId;
      if (backgroundInProgram) {
        const background = backgrounds.find(
          b => b?.source?._id === deleteParams?.replacementSource?._id
        );
        let updatedProgram = {
          ...program,
          style: {
            backgroundColor: '#000000'
          }
        };
        if (background) {
          updatedProgram = {
            ...program,
            style: {
              ...program.style,
              backgroundId: background._id,
              backgroundImage: `url(${background.source.value.url})`
            }
          };
        }
        dispatch(setProgram(updatedProgram));
        logProgramChange(
          getState,
          'updateDeletedSourceInProgram action - removing background'
        );
      }
    }
  };
};
